import { InputText } from "primereact/inputtext";

type DeviceNameInputProps = {
  name?: string;
  onNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  errorMessage?: JSX.Element;
};

const DeviceNameInput: React.FC<DeviceNameInputProps> = ({
  name,
  onNameChange,
  errorMessage,
}) => {
  return (
    <div className="p-field p-col-12">
      <label htmlFor="name">Ihre Bezeichnung</label>
      <InputText
        id="name"
        maxLength={32}
        value={name}
        placeholder="z.B. Notruf-Instanz im Eingangsbereich"
        onChange={onNameChange}
      />
      {errorMessage}
    </div>
  );
};

export default DeviceNameInput;
